export interface NameObject {
  first_name: string;
  last_name: string;
  preferred_first_name?: string | null;
}

export const getInitials = (nameObj: NameObject | null | undefined): string => {
  if (!nameObj || (!nameObj.first_name && !nameObj.last_name)) {
    return '';
  }

  const { first_name, last_name } = nameObj;
  const firstInitial = first_name?.charAt(0).toUpperCase() || '';
  const lastInitial = last_name?.charAt(0).toUpperCase() || '';

  return `${firstInitial}${lastInitial}`;
};

export const formatStudentName = (student: { first_name: string; last_name: string; preferred_first_name?: string | null }): string => {
  if (student.preferred_first_name && student.preferred_first_name.trim()) {
    return `${student.first_name} (${student.preferred_first_name}) ${student.last_name}`;
  }
  return `${student.first_name} ${student.last_name}`;
};
